import React from 'react';
import AssistantMessage from './AssistantMessage';

export function UserMessage({ message }) {
  return (
    <div className="message user cv-msg cv-msg--user">
      <div className="message-container">
        <div className="user-message">{message.text}</div>
      </div>
    </div>
  );
}

/**
 * The conversation. The last child is always the last message, so `.message.assistant:last-child` (used by
 * the batch script) finds the newest answer.
 */
export default function MessageList({
  messages, busy, onSend, onAppend, onRetry, onVote, votes,
}) {
  const lastAssistant = messages.length - 1;
  return (
    <div className="chat-window cv-list">
      {messages.map((m, i) => (m.role === 'user'
        ? <UserMessage key={m.id} message={m} />
        : (
          <AssistantMessage
            key={m.id}
            message={m}
            isLast={i === lastAssistant}
            busyGlobal={busy}
            onSend={onSend}
            onAppend={onAppend}
            onRetry={onRetry}
            onVote={onVote}
            vote={votes && m.messageId ? votes[m.messageId] : undefined}
          />
        )))}
    </div>
  );
}
